export default __webpack_public_path__ + "static/media/蔡孟宗.39877997.jpg";